export default "__VITE_ASSET__02befe4d__"